export default import.meta.ROLLDOWN_FILE_URL_HzkcZFJRXJPUL564a2jhnA